import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs';
import { useContext, useState } from 'react';

import { StaticTextContext } from '@/components/context/StaticTextProvider';

export const useCourseTypes = (useCourseTypes) => {
  const { st } = useContext(StaticTextContext);

  const [filter, setFilter] = useQueryState(
    st('courseTypes.key'),
    parseAsArrayOf(parseAsString).withDefault([]),
  );

  const [selectedCourseTypes, setSelectedCourseTypes] = useState(
    useCourseTypes.filter((c) => filter.includes(c.slug)),
  );

  const onCourseTypesChange = (courseType) => {
    const selected = useCourseTypes.filter((c) => courseType.includes(c.title));

    setSelectedCourseTypes(useCourseTypes.filter((c) => selected.includes(c)));
    setFilter(selected.map((c) => c.slug));
  };

  return { selectedCourseTypes, onCourseTypesChange };
};
